// File: client/src/variants/uno/rulebook.js
// Canonical rulebook for UNO X CHESS. Keep in sync with the card catalog
// (server/db/cardDefinitions.js) and the effect engine.

const rulebook = {
  overview:
    'Standard chess, but each player holds a hand of UNO-inspired cards. Once per turn you may play one card that temporarily bends the rules — grant yourself extra moves, skip your opponent, flip the board, and more.',
  objective:
    'Checkmate the opponent’s king, exactly as in classic chess. Cards change how you get there, not the goal.',
  setup:
    'Each side starts with a hand of 3 cards drawn from a shared, rarity-weighted deck (common ×4, uncommon ×2, rare ×1). Hands hold up to 5 cards; you draw 1 at the end of each of your turns.',
  turnFlow: [
    'Optionally play ONE card from your hand.',
    'Make your move(s). A normal turn is one move; some cards grant more.',
    'If a card gives extra moves, you may not move the same piece twice in a row.',
    'Checkmate ends the game immediately, even mid-combo.',
    'Draw a card (if your hand isn’t full), then play passes to your opponent.',
  ],
  mechanics: [
    {
      title: 'Number cards (Two / Three / Four)',
      body: 'Make that many legal moves this turn instead of one. You cannot move the same piece on consecutive moves. Every individual move must still be legal.',
    },
    {
      title: 'Draw Two / Draw Four',
      body: 'Grant 2 or 4 extra moves this turn (3 or 5 total), same rules as number cards.',
    },
    {
      title: 'Skip',
      body: 'Your opponent loses their next turn — you move again.',
    },
    {
      title: 'Reverse',
      body: 'The board flips 180° and control swaps: you continue from the opponent’s side. The swap takes effect at the turn boundary so control stays consistent.',
    },
    {
      title: 'Trade Hands',
      body: 'Swap your remaining hand of cards with your opponent’s.',
    },
    {
      title: 'Knight Fever',
      body: 'For your turn, all of your pieces move like knights.',
    },
    {
      title: 'Tiny Queen',
      body: 'Your queen may move at most 3 squares this turn.',
    },
    {
      title: 'Pawn Riot',
      body: 'Every one of your pawns that can legally advance one square does so immediately, then you take your normal turn.',
    },
  ],
  winConditions: [
    'Win by checkmate (including a checkmate delivered during a multi-move turn or by Pawn Riot).',
    'Win if the opponent resigns or runs out of time.',
    'Draw by stalemate.',
  ],
  tips: [
    'Save Skip and number cards for a tactical breakthrough — two moves in a row can win material.',
    'Reverse is chaotic: only play it when the opponent’s position is worse than yours.',
    'Knight Fever can escape pins or reach squares no normal move can.',
  ],
  knownInteractions: [
    'Rule decision: only ONE card may be played per turn.',
    'Rule decision: number-card extra moves forbid moving the same piece twice consecutively, to prevent trivial shuffling.',
    'Rule decision: Reverse’s control swap is applied at the end of the turn that played it, so the human is never locked out mid-turn vs the AI.',
    'Rule decision: Pawn Riot advances are applied through the engine and can themselves deliver checkmate; the player still takes their normal move afterward.',
    'AI: the computer plays standard chess and does not play cards. Card effects still apply to it (e.g. it can be Skipped). Movement-changing cards you play alter only your own turn.',
  ],
};

export default rulebook;
